/*
    模块组件
    JarunWang

    说明
    游戏详情里的推荐下载的游戏

    版本
    1.0

    传参
        type string  类型 list|detail
        itme object  数据

    案例
    <live-box type = "list" :item= "item" v-for="item in onLives"></live-box>
*/
<template>
    <div class = "live_box">
        <div>
            <div class = "title"  v-if="type == 'detail'" >正在直播</div>
            <div class = "title" v-else >{{ item.subject }}</div>
            <a href = "javascript:;" v-if="type == 'detail'" @click = "goState({name: 'find', query: {page: 'livestream'}})" class = "more_btn">更多>></a>
        </div>
        <div class="video_item" @click="jumpShow(item)">
            <span class="video_item_type"><i></i>直播中</span>
            <img class="video_item_photo" :src="item.cover" />
            <span class="video_item_name"><img :src="item.avatar"/>{{ item.name }}</span>
        </div>
        <div class="video_game">
            <div class="video_game_msg" v-if="type == 'detail'" >{{ item.subject }}</div>
            <div class="video_game_des">
                <span class="video_game_des_left">
                    <img :src="item.game_icon" />
                    {{ item.game_name }}
                </span>
                <!-- <span class="video_game_des_right">
                    这里5.1万 在看
                </span> -->
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import router from "@/router"
import Util from '@/assets/js/lib/util';
import { Button } from "vant"

export default defineComponent({
    name: 'LiveBox',
    components: { Button },
    props: {
        type: {
            type: String
        },
        item: {
            type: Object
        }
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
        });
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            jumpShow: (item) => {
                state.util.winOpen(item.live_room);
            }
        }; //需要对外暴露的方法


        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./LiveBox.less";
</style>